import { useTranslation } from 'react-i18next'
import { useLidoSDK } from '.'
import { useDebounce } from '~/hooks'
import useSWR from 'swr'
import { parseEther } from 'viem'
import { useWithdrawalBaseData } from './useWithdrawalBaseData'
import { DEFAULT_WITHDRAWAL_WAITING_TIME_DAYS } from '../constants'

export const useWaitingTime = (amount: string | null) => {
  const { t } = useTranslation()
  const { withdraw } = useLidoSDK()
  const { isBunker, isPaused } = useWithdrawalBaseData()
  const debouncedAmount = useDebounce(amount, 1000)
  const formattedAmount = debouncedAmount ? parseEther(debouncedAmount) : null

  const { data, isValidating } = useSWR(
    ['lido-withdrawal-waiting-time', formattedAmount?.toString()],
    () =>
      withdraw.waitingTime.getWithdrawalWaitingTimeByAmount({
        amount: formattedAmount != null ? formattedAmount : undefined,
      }),
  )

  const ms = data?.requestInfo?.finalizationIn
  const days = ms
    ? Math.ceil(ms / (24 * 60 * 60 * 1000))
    : DEFAULT_WITHDRAWAL_WAITING_TIME_DAYS

  const waitingTime =
    days && days > 1 ? `~ ${days} ${t('days')}` : `~ ${days} ${t('day')}`
  const value = isPaused ? '—' : isBunker ? 'Not estimated' : waitingTime

  return {
    ...data,
    days,
    value,
    isValidating,
  }
}
